var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectToDummoBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 710,
    viewBox: "0 0 650 710",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_16)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 710,
    rx: 20,
    fill: "#F8F8FB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 710,
    rx: 20,
    fill: "url(#paint0_linear_1_16)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.94,
    filter: "url(#filter0_i_1_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754 150.5C754 177.788 743.223 203.972 724.015 223.355C704.806 242.737 678.72 253.75 651.433 253.996C624.146 254.242 597.866 243.702 578.311 224.669C558.756 205.635 547.509 179.65 547.017 152.366C546.525 125.082 556.828 98.7081 575.684 78.9824C594.54 59.2567 620.423 47.7758 647.701 47.0379C674.979 46.2999 701.445 56.3646 721.34 75.042C741.235 93.7193 752.949 119.498 753.933 146.768L710.488 148.336C709.918 132.52 703.124 117.569 691.585 106.736C680.047 95.9039 664.697 90.0667 648.877 90.4947C633.056 90.9227 618.044 97.5813 607.109 109.022C596.173 120.462 590.197 135.758 590.482 151.582C590.768 167.406 597.291 182.477 608.632 193.516C619.973 204.554 635.215 210.668 651.041 210.525C666.867 210.382 681.996 203.995 693.137 192.754C704.277 181.513 710.527 166.326 710.527 150.5H754Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_16",
    x: 547,
    y: 47,
    width: 207,
    height: 210,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.772135 0 0 0 0 0.270833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_16",
    x1: 325,
    y1: 0,
    x2: 325,
    y2: 710,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 710,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectToDummoBackground);
export default __webpack_public_path__ + "static/media/ConnectToDummoBackground.1475856244c158f047fc12259a0ef7be.svg";
export { ForwardRef as ReactComponent };